module.exports = __webpack_public_path__ + "static/media/sunny.0e8eb8e3.svg";